import React, { useState } from 'react'
import ReactSlidingPane from 'react-sliding-pane'
import DisplayTrigger from '../display-types/DisplayTrigger'
import { SliderProps } from '../display-types/DisplayTrigger.d'
import Themes from '../../themes/Themes'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import {
    changeTopNav,
    toggleSideNav,
} from '../../../features/settings/settings.slice'

const AppSettings: React.FC<SliderProps> = ({
    title,
    className,
    trigger,
    width = '35rem',
}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const { type: triggerType = 'button', title: triggerTitle } = trigger

    const sideNaveToggled: boolean = useAppSelector(
        (state) => state.settings.sideNav.toggled
    )
    const topNavFixed: boolean = useAppSelector(
        (state) => state.settings.topNav.fixed
    )

    const dispatch = useAppDispatch()

    return (
        <>
            <OverlayTrigger
                placement="bottom"
                trigger={['hover', 'focus']}
                show={!isOpen ? undefined : false}
                overlay={
                    <Tooltip id="tooltip-bottom" style={{ margin: 0 }}>
                        Settings
                    </Tooltip>
                }
            >
                {({ ref, ...triggerHandler }) => (
                    <DisplayTrigger
                        title={triggerTitle}
                        type={triggerType}
                        setIsOpen={setIsOpen}
                        className={className}
                        itemRef={ref}
                        extraProps={triggerHandler}
                    />
                )}
            </OverlayTrigger>

            <ReactSlidingPane
                isOpen={isOpen}
                title={title}
                width={width}
                onRequestClose={() => setIsOpen(false)}
                onAfterOpen={() => {
                    document.body.style.overflow = 'hidden'
                }}
                onAfterClose={() => {
                    document.body.style.overflow = 'initial'
                }}
            >
                <Themes
                    type="switch"
                    label="Switch Theme"
                    altThemeName="dark"
                />
                <hr />
                <Form.Check
                    type="switch"
                    id="toggle-side-nav-switch"
                    label="Toggle Side Navigation"
                    onChange={() => dispatch(toggleSideNav(!sideNaveToggled))}
                    checked={sideNaveToggled}
                />
                <hr />
                <Form.Check
                    type="switch"
                    id="change-top-nav-switch"
                    label="Top Bar Fixed"
                    onChange={() => dispatch(changeTopNav(!topNavFixed))}
                    checked={topNavFixed}
                />
            </ReactSlidingPane>
        </>
    )
}

export default AppSettings
